import { Box } from "@mui/material";
import HeaderMain from "../../components/common/HeaderMain/HeaderMain";
import HelpCenter from "../HelpCenter/HelpCenter";
import Footer from "../../components/single/Footer/Footer";
import styles from "./HelpCenterBase.module.css";

const HelpCenterBase = () => {

  return (
    <Box className={styles.HelpCenterBase}>
        <HeaderMain />
        <HelpCenter />
        <Footer />
    </Box>
  );
};

export default HelpCenterBase;